((angular) => {
  'use strict';

  angular
    .module('App')
    .factory('PositionTypeService', ['$http', 'API', PositionTypeService]);

  function PositionTypeService($http, API) {
    const list = (params) => {
      if (params) {
        params.direction = 'asc';
      }

      if (params && params.orderBy && params.orderBy[0] === '-') {
        params.orderBy = params.orderBy.replace('-', '');
        params.direction = 'desc';
      }

      return $http({
        method: 'GET',
        url: `${API}/positionType`,
        params: params,
      }).then((res) => res.data);
    };

    return {
      list,
    };
  }
})(angular);
